import { useContext } from 'react';
import { TailwindThemeContext } from '../../contexts/tailwindThemeContext';

const useVariants = () => {
  const context = useContext(TailwindThemeContext);
  if (context === undefined) throw new Error('Invalid tailwind theme context.');
  return {
    variants: context.variants,
    setVariants: context.setVariants,
  };
};

export { useVariants };
